const header = document.querySelector("[data-header]");
const quickAddButtons = document.querySelectorAll(".quick-add");
const customizers = document.querySelectorAll("[data-customizer]");

const updateHeader = () => {
  if (!header) return;
  header.classList.toggle("is-scrolled", window.scrollY > 20);
};

window.addEventListener("scroll", updateHeader, { passive: true });
updateHeader();

quickAddButtons.forEach((button) => {
  button.addEventListener("click", async () => {
    const variantId = button.dataset.variantId;
    const productName = button.dataset.product || "Demo graphic";

    if (!variantId) {
      if (button.form) return;
      window.location.href = "/#customize";
      return;
    }

    button.disabled = true;
    button.textContent = "Adding";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: {
            "Demo graphic": productName,
            Placement: "Front center",
          },
        }),
      });

      if (!response.ok) throw new Error("Add to cart failed");

      button.textContent = "Added";
      button.setAttribute("aria-label", `${productName} added`);
      window.location.href = "/cart";
    } catch (error) {
      button.disabled = false;
      button.textContent = "Try Again";
      button.setAttribute("aria-label", `Add ${productName} to cart`);
    }
  });
});

customizers.forEach((customizer) => {
  const input = customizer.querySelector("[data-upload-input]");
  const preview = customizer.querySelector("[data-upload-preview]");
  const placeholder = customizer.querySelector("[data-upload-placeholder]");
  const scale = customizer.querySelector("[data-upload-scale]");
  const x = customizer.querySelector("[data-upload-x]");
  const y = customizer.querySelector("[data-upload-y]");

  const updatePlacement = () => {
    const scaleValue = scale ? scale.value : 100;
    const xValue = x ? x.value : 0;
    const yValue = y ? y.value : 0;
    customizer.style.setProperty("--upload-scale", `${scaleValue / 100}`);
    customizer.style.setProperty("--upload-x", `${xValue}%`);
    customizer.style.setProperty("--upload-y", `${yValue}%`);
  };

  input?.addEventListener("change", () => {
    const file = input.files?.[0];
    if (!file || !preview) return;
    preview.src = URL.createObjectURL(file);
    preview.classList.add("is-visible");
    placeholder?.classList.add("is-hidden");
  });

  [scale, x, y].forEach((control) => {
    control?.addEventListener("input", updatePlacement);
  });

  updatePlacement();
});
